import { QueryFunctionContext, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import locationService from '../services/location.service';
import { HealthComLocation } from '@chiroup/core/types/HealthComLocation.type';

const getQuery = () => {
  return async (context: QueryFunctionContext) => {
    const path = context.queryKey[1] as string;
    if (!path) return {};
    return locationService.getLocation(path);
  };
};

const useLocation = () => {
  const { path } = useParams();

  const { status, data, error, isFetching, refetch } =
    useQuery<HealthComLocation>(['location', path], getQuery(), {
      refetchOnWindowFocus: false,
      retry: false,
    });

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
    path,
  };
};

export default useLocation;
